<script>
  /* Executable code section of the program */
  //Tool importation
  import {
    alertMessagge,
    isAlertOn,
    isAttendeeCardModalOn,
    temporalAttendeeData,
    deleteMessagge,
    confirmResponse,
    isConfirmModalOn,
    isReloadNecessary
  } from "../../apis/storage";
  import { deleteDocument } from "../../apis/APIS";

  //Component importation
  import ConfirmModal from "../Modals/ConfirmModal.svelte"

  //Auxiliary Variables
  export let user;  

  //Function to undisplay modal
  const undisplayModal = () => {
    $isAttendeeCardModalOn = false;
  };
  //function to display alert
  const displayAlert = () => {
    $isAlertOn = true;
  };

  //Function to display confirm modal
  const displayConfirmModal = () =>{
    $isConfirmModalOn = true
    $alertMessagge = "Are you sure you want to delete this user?"
  }

  //Function to delete attendee
  const deleteAttendee = async() => {
    if (user == "attendee") {
      if ($confirmResponse) {
        deleteDocument("users", $temporalAttendeeData.id)
          .then(() => {
            $isAttendeeCardModalOn = false;
            $alertMessagge = "The attendee was successfully deleted from the event."
            displayAlert();
            $isReloadNecessary = true
          })
          .catch(() => {
            $alertMessagge = "An error occurred while deleting the attendee.". 
            displayAlert();
          });
      }
    } else {
      if ($confirmResponse) {        
        deleteDocument("coordinators", $temporalAttendeeData.id)
          .then(() => {
            deleteDocument("users",$temporalAttendeeData.id)
            $isAttendeeCardModalOn = false;
            $alertMessagge = "The coordinator was successfully deleted from the event."
            displayAlert();
            $isReloadNecessary = true 
          })
          .catch(() => {
            $alertMessagge = "An error occurred while deleting the coordinator.";
            displayAlert();
          });
      }
    }
  };

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="modalSection">
  <div class="cardContainer">
    <div class="headerCard">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-x-circle icon"
        viewBox="0 0 16 16"
        on:keypress={() => undisplayModal()}
        on:click={() => undisplayModal()}
      >
        <path
          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
        />
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
        />
      </svg>
    </div>
    <div class="bodyCard">
      <div class="imgAvatar">
        {#if $temporalAttendeeData.profileImgUrl === ""}
          <div class="avatarEmpty">
            <h1 class="letterAvatar">
              {$temporalAttendeeData.name.slice(
                0,
                1
              )}{$temporalAttendeeData.surname.slice(0, 1)}
            </h1>
          </div>
        {:else}
          <img src={$temporalAttendeeData.profileImgUrl} alt="avatarProfile" />
        {/if}
      </div>
      <h4>{$temporalAttendeeData.name} {$temporalAttendeeData.surname}</h4>
      <p>{$temporalAttendeeData.jobtittle}</p>
      <p>{$temporalAttendeeData.company || $temporalAttendeeData.department}</p>
      <p>{$temporalAttendeeData.country}</p>
    </div>
    <div class="footerCard">
      <button class="actionBtn" on:click={displayConfirmModal}
        >Delete Attendee</button
      >
    </div>
  </div>
</section>
{#if $isConfirmModalOn}
<ConfirmModal callbackFunction = {deleteAttendee}/>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .modalSection {
    position: fixed;
    top: 0;
    z-index: 888;
    width: 100%;
    height: auto;
    min-height: 160vh;
    background-color: rgba(0, 0, 0, 0.432);
    padding: 30px;
    display: flex;
    justify-content: center;
  }
  .cardContainer {
    background-color: #f4f4f4;
    width: 25%;
    height: 50%;
    padding: 10px;
  }
  .headerCard {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 15px;
  }
  .icon:hover {
    cursor: pointer;
    color: #ed2824;
  }
  .bodyCard {
    width: 100%;
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .imgAvatar {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 15px 0;
  }
  .avatarEmpty {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #004d40;
  }
  .letterAvatar {
    color: white;
  }
  img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  p {
    line-height: 0.6;
  }
  .footerCard {
    width: 100%;
    padding: 15px;
    display: flex;
    justify-content: center;
  }
  .actionBtn {
    width: 250px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 20px;
  }

  .actionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .cardContainer {
      background-color: #f4f4f4;
      width: 45%;
      height: 50%;
      padding: 10px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .modalSection {
      position: fixed;
    }
    .cardContainer {
      background-color: #f4f4f4;
      width: 85%;
      height: 50%;
      padding: 10px;
    }
  }

  /* End of the section */
</style>
